import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createElementVNode as _$ce, className as _$cn, createVNode as _$cv } from 'intact-vue-next';
import { directClone } from 'intact-vue-next';
import { mapChildren, getRestProps } from '../utils';
import { Menu } from '../menu';
import { makeAsideStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    collapse = _this$get.collapse,
    fixed = _this$get.fixed,
    theme = _this$get.theme;
  var k = this.config.k;
  var vNodes = mapChildren(children, function (vNode) {
    if (vNode.tag === Menu) {
      var vNodeClone = directClone(vNode);
      vNodeClone.props = _extends({}, vNode.props, {
        collapse: collapse
      });
      return _$ce(2, 'div', vNodeClone, 0, _$cn(k + "-layout-wrapper"));
    }
    return vNode;
  });
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-layout-aside"] = true, _classNameObj[k + "-collapsed"] = collapse, _classNameObj[k + "-fixed"] = fixed, _classNameObj[k + "-" + (theme === 'dark' ? 'dark' : 'light')] = true, _classNameObj[className] = className, _classNameObj[makeAsideStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'style': this.getStyles(k)
  }), vNodes);
}
;